import React, { PureComponent } from 'react'
// import './styles.scss'
import PropTypes from 'prop-types'
import get from 'lodash.get'
import Select from 'react-select'

class SelectMultiple extends PureComponent {

  getOptionLabel = (option) => {
    return this.props.optionLabelKey ? get(option, this.props.optionLabelKey, '?') : option.label
  }

  getOptionValue = (option) => {
    return this.props.optionValueKey ? get(option, this.props.optionValueKey, undefined) : option.value
  }

  render () {
    const classNames = ['SelectMultiple']
    if (this.props.type) {
      classNames.push('SelectMultiple-' + this.props.type)
    }

    let label = ''
    if (this.props.label !== undefined) {
      label = <label>{this.props.label + (this.props.required ? ' *' : '')}</label>
    }

    let message
    if (this.props.valid !== true) {
      if (this.props.message) {
        message = <span>{this.props.message}</span>
      }
      classNames.push('SelectError')
    }

    const value = (this.props.selected === null || this.props.selected === undefined) ? '' : this.props.selected
    return (
      <div>
        {label} {message}
        <div className={'select-wrap-multiple'}>
          <Select
            className={classNames.join(' ')}
            value={value}
            isMulti={true}
            getOptionLabel={this.getOptionLabel}
            getOptionValue={this.getOptionValue}
            placeholder={this.props.placeholder}
            isDisabled={this.props.disabled}
            onChange={this.props.onChange}
            options={this.props.options}
          />
        </div>
      </div>
    )
  }
}

SelectMultiple.defaultProps = {
  placeholder: '',
  required: false,
  disabled: false,
  valid: true
}

SelectMultiple.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  selected: PropTypes.any,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  valid: PropTypes.bool,
  message: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  optionLabelKey: PropTypes.any,
  optionValueKey: PropTypes.any
}

export default SelectMultiple
